import React from 'react';
import {useAppCheckoutEntryDetails} from '../hooks/useCheckoutEntryDetails';
import {CheckoutDataLayerInterceptor} from './CheckoutDataLayerInterceptor';

export const AppCheckoutDataLayerInterceptor: React.FC = () => {
  const checkoutEntryDetails = useAppCheckoutEntryDetails();

  return (
    <CheckoutDataLayerInterceptor
      device="app"
      gaSessionId={checkoutEntryDetails.appConfig?.ga_session_id}
      checkoutEntryDetails={checkoutEntryDetails}
    />
  );
};
